document.addEventListener('DOMContentLoaded', function () {
  const SEC = '#shopify-section-template--20092755968136__featured_collection_carousel_WCDJpL';
  const section = document.querySelector(SEC);
  if (!section) return;

  setTimeout(function () {
    if (section.querySelector('.sd-nav-custom')) return;

    // Pega o grid/lista de produtos — insere DEPOIS dele
    const productGrid = section.querySelector(
      '.hdt-slider__viewport, .hdt-slider-wrap, hdt-reval-items, .hdt-row-grid, .hdt-row-flex'
    );
    if (!productGrid) return;

    const nav = document.createElement('div');
    nav.className = 'sd-nav-custom';
    nav.style.cssText = 'display:flex;justify-content:center;align-items:center;gap:24px;margin-top:20px;width:100%;padding-bottom:8px;';

    function makeBtn(direction) {
      const btn = document.createElement('button');
      btn.setAttribute('type', 'button');
      btn.style.cssText = [
        'width:52px',
        'height:52px',
        'min-width:52px',
        'border-radius:50%',
        'background:#fff',
        'border:4px solid #111',
        'display:flex',
        'align-items:center',
        'justify-content:center',
        'cursor:pointer',
        'padding:0',
        'box-shadow:none',
        'transition:transform 0.1s ease',
      ].join(';');

      const arrow = direction === 'prev'
        ? `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="#111" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
           </svg>`
        : `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 6L15 12L9 18" stroke="#111" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
           </svg>`;

      btn.innerHTML = arrow;

      btn.addEventListener('mouseenter', () => btn.style.transform = 'scale(1.08)');
      btn.addEventListener('mouseleave', () => btn.style.transform = 'scale(1)');
      btn.addEventListener('mousedown', () => btn.style.transform = 'scale(0.94)');
      btn.addEventListener('mouseup', () => btn.style.transform = 'scale(1)');

      return btn;
    }

    const prev = makeBtn('prev');
    const next = makeBtn('next');

    prev.addEventListener('click', () => {
      const native = section.querySelector('[name="previous"]') ||
                     section.querySelector('.hdt-hidden-slider-nav button:first-child');
      if (native) native.click();
    });

    next.addEventListener('click', () => {
      const native = section.querySelector('[name="next"]') ||
                     section.querySelector('.hdt-hidden-slider-nav button:last-child');
      if (native) native.click();
    });

    nav.appendChild(prev);
    nav.appendChild(next);

    // Insere DEPOIS do grid de produtos
    productGrid.parentNode.insertBefore(nav, productGrid.nextSibling);

  }, 1000);
});